import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction, userActions } from "../../_actions";
import { LanguageContext } from "../../context/LanguageContext";
import { AppTable } from "../../_components/AppTable";
import {
  Drawer,
  Form,
  Button,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Modal,
  Spin,
  Space,
} from "antd";
import { Document8 } from "./ReportDocuments/Document_8";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import ReportsTable from "./ReportsTable";
import * as XLSX from "xlsx-js-style";
import moment from "moment";
import { roleAction } from "../../_actions/roleby.action";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
const TableReportAdminSpotvise = React.lazy(() =>
  import("./Tables/TableReportAdminSpotvise").then((module) => ({
    default: module.TableReportAdminSpotvise,
  })),
);

const TableReportPoliceSpotvise = React.lazy(() =>
  import("./Tables/TableReportPoliceSpotvise").then((module) => ({
    default: module.TableReportPoliceSpotvise,
  })),
);

const { RangePicker } = DatePicker;
const { Option } = Select;

class ReportAdminSpotvise extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }

  state = {
    loading: false,
    downloadLoding: false,
    report_3_startDate: "",
    report_3_endDate: "",
    report_1_startDate: "",
    report_1_endDate: "",
    report1_List: [],
    report1_List_Total: null,
    report1_API_loader: false,
    report1_Total: null,
    setCriminalViewModel: false,
    report2_List: [],
    report2_List_Total: null,
    report2_Total: null,
    download: "",
  };

  componentDidUpdate() {
    // const { authentication } = this.props;
    // if(authentication && authentication.user && authentication.user.role==='2'){
    //   return <Redirect to='/login'  />
    // }
  }

  componentDidMount() {}

  downloadReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_1_startDate,
      endDate: this.state.report_1_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report1_loader: true,
    });
    const blob = await pdf(
      <Document8
        rows={this.state.report1_List}
        filterDate={obj}
        total={this.state.report1_List_Total}
      />,
    ).toBlob();

    if (blob) {
      this.setState({
        report1_loader: false,
      });
      saveAs(blob, "Report Spot Vise");
    }
  };

  download_csv = () => {
    var ReportTitle = "report_spot_vise";
    var title = "Report Spot Vise";
    var arrData1 = this.state.report1_List;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list =
      arrData1?.map((data, index) => ({
        "अ.क्र": index + 1,
        "Police Station": data.policeThane,
        "Total Spot": data.allTotalSpot,
        "Total Visited Spot": data.taggedLocations,
        "%": data.totalPerSpots,
        "Incharge Name and Mobile No":
          data.inchargeName && data.inchargePhone
            ? data.inchargeName / data.inchargePhone
            : "-",
      })) || [];

    const arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `${
        moment(this.state.report_1_startDate).format("DD-MM-YYYY") || "-"
      } }`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  getExportRows = () => {
    const { t } = this.context;
    const arrData1 = this.state.report1_List;

    return (
      arrData1?.map((data, index) => ({
        "अ.क्र": index + 1,
        "Police Station": data.policeThane,
        "Total Spot": data.allTotalSpot,
        "Total Visited Spot": data.taggedLocations,
        "%": data.totalPerSpots,
        "Incharge Name and Mobile No":
          data.inchargeName && data.inchargePhone
            ? data.inchargeName / data.inchargePhone
            : "-",
      })) || []
    );
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = "Report Spot Vise";
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        dateRangeText: getReportDateRangeText(this.state.report_1_startDate),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };
  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };
  generatePDFReport1 = async () => {
    const { user } = this.props;
    this.setState({
      report1_API_loader: true,
    });
    if (user.role === "4") {
      let obj = {
        startDate: this.state.report_1_startDate,
        endDate: this.state.report_1_endDate,
        cityId: user && user.cityId,
      };

      professionalAction.getReportAdminSpotvise(obj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            const tempFilterData = _.filter(
              tempData && tempData.data,
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            this.setState({
              report1_API_loader: false,
              report1_List: tempFilterData,
              report1_List_Total: tempData && tempData.allTotalSpot,
              report1_Total: tempData && tempData.allTotalSpot,
            });
          });
      });
    }
    if (user.role === "9" || user.role === "10") {
      let obj = {
        startDate: this.state.report_1_startDate,
        endDate: this.state.report_1_endDate,
        districtId: user && user.map_districtId,
      };

      roleAction.getReportSpotviseByRole(obj).then((res) => {
        res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            const tempFilterData = _.filter(
              tempData?.data,
              (o) => Object.keys(o).length !== 0,
            );
            this.setState({
              report1_API_loader: false,
              report1_List: tempFilterData,
              report1_List_Total: tempData?.allTotalSpot,
              report1_Total: tempData?.allTotalSpot,
            });
          });
      });
    }
  };

  onFinishDateRangeGPSTable = (values) => {
    if (values) {
      this.setState({
        report_3_startDate: values.toISOString(),
      });
    }
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      this.setState({
        report_1_startDate: values.toISOString(),
      });
    }
  };

  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      let obj = {
        startDate: this.state.report_1_startDate,
        endDate: this.state.report_1_endDate,
        districtId: data,
      };
      this.setState({
        report1_API_loader: true,
      });
      professionalAction.getReportPoliceSpotvise(obj).then((res) => {
        res &&
          res &&
          res.text().then(async (text) => {
            const tempData = text && JSON.parse(text);
            const tempFilterData = _.filter(
              tempData && tempData.data,
              function (o) {
                return Object.keys(o).length !== 0;
              },
            );
            this.setState({
              report1_API_loader: false,
              report2_List: tempFilterData,
              report2_List_Total: tempData && tempData.allTotalCriminals,
              report2_Total: tempData && tempData.totalCriminals,
            });
          });
      });
    }
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  handleDownload = () => {
    console.log("handleDownload", this.myTableRef.current);
    if (this.myTableRef.current) {
      this.myTableRef.current.handleDownloadPDF();
    }
    this.isloading();
  };

  render() {
    const { t } = this.context;
    console.log("pagination");
    const { users } = this.props;
    const { user } = this.props;
    const { professionals } = this.props;
    const { pc_cities, loading } = professionals;

    return (
      <Spin spinning={this.state.loading} delay={500}>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              // title={"Report Spot Vise"}
              title={t("report_spot_vise")}
              // extra={[
              //   <Button key="1" type="primary" disabled={!this.state.report1_List.length} loading={this.state.report1_loader} onClick={this.downloadReport1}>
              //     Download
              //   </Button>,
              // ]}
            >
              <Descriptions size="small" column={2}>
                <Descriptions.Item label="Select Date">
                  <DatePicker
                    style={{ marginRight: 10 }}
                    onChange={(val) => this.onFinishDateRangeGPSReport1(val)}
                    inputReadOnly
                    format={"DD/MM/YYYY"}
                    placeholder="DD/MM/YYYY"
                  />
                  <Button
                    key="1"
                    type="primary"
                    disabled={!this.state.report_1_startDate}
                    onClick={this.generatePDFReport1}
                  >
                    Find
                  </Button>
                  <div style={{ paddingLeft: "45%" }}>
                    {/* download report */}
                    {/* <Space>
                      <Button
                        key="1"
                        type="primary"
                        disabled={!this.state.report1_List.length}
                        loading={this.state.report1_loader}
                        //  onClick={this.downloadReport1}
                      >
                        Download
                      </Button>
                      <Button
                        type="primary"
                        icon={<FilePdfOutlined />}
                        onClick={this.downloadReport1}
                        disabled={!this.state.report1_List.length}
                        style={{ marginLeft: "10px" }}
                      />
                      <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        onClick={this.download_csv}
                        disabled={!this.state.report1_List.length}
                      />
                    </Space> */}
                    <Space direction="horizontal" size="middle">
                      <Form>
                        <Form.Item
                          name="condition"
                          rules={[
                            {
                              required: true,
                              message: t("please_select_an_option"),
                            },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <Select
                            placeholder={t("please_select_an_option")}
                            value={this.state.download}
                            onChange={(value) =>
                              this.setState({ download: value })
                            }
                            style={{ width: 150 }}
                            disabled={!this.state.report1_List.length}
                          >
                            <Option key="excel" value="excel">
                              एक्सेल
                            </Option>
                            <Option key="pdf" value="pdf">
                              PDF
                            </Option>
                          </Select>
                        </Form.Item>
                      </Form>

                      {this.state.download && (
                        <Button
                          key="1"
                          type="primary"
                          style={{ minWidth: 120 }}
                          onClick={() => this.downloadReport()}
                        >
                          Download
                        </Button>
                      )}
                    </Space>
                  </div>
                </Descriptions.Item>
              </Descriptions>
            </PageHeader>
            <React.Suspense fallback={<div>Loading...</div>}>
              <TableReportAdminSpotvise
                data={this.state.report1_List}
                totalAll={this.state.report1_Total}
                total={this.state.report1_List_Total}
                userRole={user && user.role}
                onViewAccusedForm={this.onViewAccusedForm}
              ></TableReportAdminSpotvise>

              <Modal
                title="Report View"
                top
                visible={this.state.setCriminalViewModel}
                onOk={this.closeCriminalViewModel}
                onCancel={this.closeCriminalViewModel}
                width={95 + "%"}
              >
                <TableReportPoliceSpotvise
                  data={this.state.report2_List}
                  totalAll={this.state.report2_Total}
                  total={this.state.report2_List_Total}
                  userRole={user && user.role}
                  loading={this.state.report1_API_loader}
                ></TableReportPoliceSpotvise>
              </Modal>
            </React.Suspense>
          </div>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReportAdminSpotvise =
  connect(mapStateToProps)(ReportAdminSpotvise);
export { connectedReportAdminSpotvise as ReportAdminSpotvise };
